/* hs-tpd-ui.js - UI van de TPD-database met winder-advies.
   GEGENEREERD uit de goedgekeurde preview door port_to_shopify.py - niet handmatig bewerken.
   Vereist (defer, in deze volgorde): hs-tpd-data.js, hs-winder-data.js, hs-winder-match.js. */
(function () {
  const PER_PAGE = 20;
  const SHOW_A = 7;      // 7 kaarten + plek 8 = knop
  const SWATCH_MAX = 6;
  const MY_MAX = 12;

  const queryInp = document.getElementById('hs-tpd-query');
  const clearBtn = document.getElementById('hs-tpd-clear');
  const tbody    = document.getElementById('hs-tpd-tbody');
  const countEl  = document.getElementById('hs-tpd-count');
  const pagWrap  = document.getElementById('hs-tpd-pagination');
  const prevBtn  = document.getElementById('hs-tpd-prev');
  const nextBtn  = document.getElementById('hs-tpd-next');
  const pageInfo = document.getElementById('hs-tpd-page-info');
  const myBar    = document.getElementById('hs-my');
  const myChips  = document.getElementById('hs-my-chips');
  const myShow   = document.getElementById('hs-my-show');
  const myClear  = document.getElementById('hs-my-clear');
  const setPanel = document.getElementById('hs-set-panel');
  const filterEls = ['hs-f-budget', 'hs-f-aantal', 'hs-f-vendor', 'hs-f-storage', 'hs-f-led']
    .map(id => document.getElementById(id));
  // vaste referenties (het #hs-filters-element wordt verplaatst, niet herbouwd) — zo
  // leest readFilters altijd de juiste waarden, ook als het element even los is gekoppeld
  const [budgetInp, aantalSel, vendorSel, storageChk, ledChk] = filterEls;
  const isMobile = () => window.matchMedia('(max-width: 640px)').matches;
  const filtersWrap = document.getElementById('hs-filters');
  const filtersHolder = document.getElementById('hs-filters-holder');

  /* filters staan boven de winders: in het geopende rij-paneel, anders in het set-paneel */
  function parkFilters() { filtersHolder.appendChild(filtersWrap); }
  function mountFilters() {
    const rowSlot = tbody.querySelector('.hs-winders-row:not([hidden]) .hs-filters-slot');
    const setSlot = setPanel.hidden ? null : setPanel.querySelector('[data-set-slot]');
    const target = rowSlot || setSlot;
    filtersWrap.classList.toggle('in-set', !rowSlot && !!setSlot);
    (target || filtersHolder).appendChild(filtersWrap);
  }

  let filtered = [], page = 0, searchIndex = null;
  let myWatches = [];   // {key, brand, model, tpd, dir}

  const DIR_LABEL = { cw: '↻ Met de klok', ccw: '↺ Tegen de klok', bi: '⇄ Beide richtingen' };
  const DIR_CLS   = { cw: 'hs-tpd-badge--cw', ccw: 'hs-tpd-badge--ccw', bi: 'hs-tpd-badge--bi' };
  const SWATCH_FALLBACK = { zwart: '#1c1c1e', wit: '#f4f4f2', bruin: '#6b4a2f', camel: '#b98a5a',
    cognac: '#9a5b2d', petrol: '#2a5f6d', rood: '#a32020', bordeaux: '#5e1a24', groen: '#0b4228',
    navy: '#1f3a5f', blauw: '#28497c', grijs: '#8f8f8f', beige: '#d9c9a8', geel: '#e0b400',
    copper: '#b87333', koper: '#b87333', carbon: '#2e2e33', makassar: '#4a3220', macassar: '#4a3220',
    ebony: '#241a12', olive: '#5c5b3a', coffee: '#4e3a2c', ivoor: '#efe9dc', zilver: '#c0c0c4' };

  function dirInfo(d) {
    const n = window.HS_WINDER_MATCH.normDir(d);
    return { cls: DIR_CLS[n], label: DIR_LABEL[n], key: n };
  }

  function eur(p) {
    return '€ ' + p.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  /* zoek-normalisatie: kleine letters + diakrieten strippen (ö->o, é->e, à->a) zodat
     de klant zonder accenten kan typen; merk en model worden samen doorzocht */
  function normSearch(s) {
    return String(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function colorFor(name) {
    const l = name.toLowerCase();
    for (const k in SWATCH_FALLBACK) { if (l.indexOf(k) > -1) return SWATCH_FALLBACK[k]; }
    return '#cccccc';
  }

  function swatches(w) {
    if (!w.vars || w.vars.length < 2) return '';
    const dots = w.vars.slice(0, SWATCH_MAX).map(v => {
      const bg = v.hex ? 'background:' + v.hex
        : v.img ? 'background-image:url(\'' + v.img + '\')'
        : 'background:' + colorFor(v.c);
      return '<span class="hs-winder-swatch" title="' + esc(v.c) + '" style="' + bg + '"></span>';
    }).join('');
    const extra = w.vars.length > SWATCH_MAX
      ? '<span class="hs-winder-swatch-more">+' + (w.vars.length - SWATCH_MAX) + '</span>' : '';
    return '<span class="hs-winder-swatches">' + dots + extra + '</span>';
  }

  function readFilters(forSet) {
    const f = {};
    const bud = parseFloat(budgetInp.value);
    if (bud > 0) f.maxPrice = bud;
    const n = parseInt(aantalSel.value, 10);
    if (n > 0) f.n = n;   // exact aantal winder-posities (6 = 6 of meer); in set-modus vooraf gezet op aantal horloges
    const v = vendorSel.value;
    if (v) f.vendor = v;
    if (storageChk.checked) f.storage = true;
    if (ledChk.checked) f.led = true;
    return f;
  }

  function card(m) {
    const w = m.w;
    return '<a class="hs-winder-card" href="/products/' + w.h + '" target="_blank" rel="noopener">'
      + (w.img ? '<img class="hs-winder-card-photo" src="' + w.img + '" alt="' + esc(w.t) + '" loading="lazy">' : '')
      + '<div class="hs-winder-card-body">'
      + '<span class="hs-winder-card-vendor">' + w.v + '</span>'
      + '<span class="hs-winder-card-title">' + w.t + '</span>'
      + '<span class="hs-winder-card-setting">Instelling: ' + m.setting + ' TPD</span>'
      + swatches(w)
      + '<span class="hs-winder-card-price">vanaf ' + eur(w.p) + '</span>'
      + '</div></a>';
  }

  /* gedeelde resultaat-opbouw: 7 kaarten + tegel-knoppen + verborgen alternatieven */
  function resultsHtml(res, uid, hasF) {
    let html = '';
    const altTile = res.b.length
      ? '<button class="hs-winder-tile hs-winder-tile--alt" data-alt="' + uid + '" type="button">Bekijk alternatieven (' + res.b.length + ')</button>'
      : '';
    if (res.a.length) {
      html += '<p class="hs-winders-heading">Geschikte watch winders (' + res.a.length + ')</p>';
      let cells = res.a.slice(0, SHOW_A).map(card).join('');
      if (res.a.length > SHOW_A) {
        cells += '<button class="hs-winder-tile" data-more="' + uid + '" type="button">Toon alle ' + res.a.length + ' geschikte winders</button>';
      } else {
        cells += altTile;
      }
      html += '<div class="hs-winders-grid" id="' + uid + '-a">' + cells + '</div>';
    } else {
      html += '<div class="hs-winders-empty">Geen winder met een instelling binnen 200 TPD'
        + (hasF ? ' binnen uw filters' : '') + (res.b.length ? ', bekijk daarom de alternatieven hieronder.' : '.') + '</div>';
    }
    if (res.b.length) {
      html += '<div id="' + uid + '-b"' + (res.a.length ? ' hidden' : '') + '>'
        + '<p class="hs-winders-heading hs-winders-heading--alt">Alternatieven (' + res.b.length + ')</p>'
        + '<p class="hs-winders-b-note">Deze watch winders draaien meer omwentelingen per dag dan uw horloge vraagt. '
        + 'De meeste moderne automatische horloges hebben een slipkoppeling die het uurwerk beschermt, waardoor een hogere TPD geen probleem hoeft te zijn. '
        + 'Wij adviseren wel om niet meer dan ongeveer 200 TPD boven de aanbevolen waarde te gaan; nog hogere instellingen laten het uurwerk onnodig doordraaien. '
        + 'Let op: oudere horloges hebben niet altijd een betrouwbare slipkoppeling, waardoor er wel een risico op overwinden bestaat. Kies in dat geval een winder die de aanbevolen TPD zo dicht mogelijk benadert. '
        + 'De dichtstbijzijnde instelling staat bij elke winder vermeld.</p>'
        + '<div class="hs-winders-grid">' + res.b.map(card).join('') + '</div></div>';
    }
    return html;
  }

  function windersPanel(tpd, dirRaw, uid) {
    const dir = dirInfo(dirRaw);
    const f = readFilters();
    const hasF = Object.keys(f).length > 0;
    const res = window.HS_WINDER_MATCH.matches(parseInt(tpd, 10), dir.key, f);
    let html = '<div class="hs-winders-panel">';
    html += '<div class="hs-filters-slot"></div>';
    if (!res.a.length && !res.b.length) {
      html += '<div class="hs-winders-empty">'
        + (hasF
          ? 'Geen winders gevonden binnen uw filters. Pas de filters hierboven aan voor meer resultaten.'
          : 'Voor deze instelling hebben wij momenteel geen geschikte watch winder in de collectie.')
        + '</div>';
      return html + '</div>';
    }
    return html + resultsHtml(res, uid, hasF) + '</div>';
  }

  /* ===== Mijn horloges ===== */
  /* in set-modus staat het aantal-filter standaard op het aantal toegevoegde horloges
     (2 horloges -> "2", 3 -> "3", 5 of meer -> "6 of meer"); opties zijn 1/2/3/4/6 */
  function syncAantalToCount() {
    const n = myWatches.length;
    aantalSel.value = n >= 5 ? '6' : String(Math.max(1, n));
  }

  function renderMyBar() {
    const hint = document.getElementById('hs-my-hint');
    hint.hidden = myWatches.length > 0;
    myShow.hidden = myWatches.length === 0;
    myClear.hidden = myWatches.length === 0;
    myChips.innerHTML = myWatches.map((wt, i) =>
      '<span class="hs-my-chip"><span class="hs-my-chip-text"><b>' + esc(wt.brand) + '</b> ' + esc(wt.model) + '</span>'
      + '<span class="hs-my-chip-specs">' + wt.tpd + ' TPD <span class="hs-tpd-badge ' + DIR_CLS[wt.dir] + '">' + DIR_LABEL[wt.dir] + '</span></span>'
      + '<button class="hs-my-chip-x" data-myx="' + i + '" type="button" aria-label="Verwijderen">&#10005;</button></span>'
    ).join('');
    myShow.textContent = 'Toon geschikte winders voor mijn ' + myWatches.length + ' horloge' + (myWatches.length > 1 ? 's' : '');
    if (!myWatches.length) { parkFilters(); setPanel.hidden = true; setPanel.innerHTML = ''; aantalSel.value = ''; mountFilters(); }
    else if (!setPanel.hidden) { syncAantalToCount(); renderSetPanel(); }
    // plus-knoppen status bijwerken
    tbody.querySelectorAll('.hs-tpd-add-btn').forEach(b => {
      b.classList.toggle('is-added', myWatches.some(wt => wt.key === b.dataset.key));
    });
  }

  function renderSetPanel() {
    parkFilters();
    // set-paneel en rij-paneel sluiten elkaar uit: nooit twee winder-adviezen tegelijk open
    // (anders divergeren de resultaten en belanden de filters in het verkeerde paneel)
    tbody.querySelectorAll('.hs-winders-row:not([hidden])').forEach(p => { p.hidden = true; });
    tbody.querySelectorAll('.is-open').forEach(x => x.classList.remove('is-open'));
    const watches = myWatches.map(wt => ({ tpd: wt.tpd, dir: wt.dir }));
    const f = readFilters(true);
    const hasF = Object.keys(f).length > 0;
    const res = window.HS_WINDER_MATCH.matchesSet(watches, f);
    let html = '<button class="hs-set-close" data-setclose type="button" aria-label="Sluiten">&#10005;</button>';
    html += '<div class="hs-winders-panel">';
    html += '<div class="hs-winders-advice">Winders geschikt voor <strong>al uw ' + watches.length + ' horloges</strong> tegelijk'
      + (hasF ? '<span class="hs-winders-filternote">· uw filters zijn toegepast</span>' : '')
      + '</div>';
    html += '<div class="hs-filters-slot" data-set-slot></div>';
    if (!res.a.length && !res.b.length) {
      html += '<div class="hs-winders-empty">Geen enkele winder kan al uw horloges tegelijk aan'
        + (hasF ? ' binnen uw filters' : '')
        + '. Tip: verdeel uw horloges over meerdere winders, of verwijder een horloge uit de lijst.</div>';
    } else {
      html += resultsHtml(res, 'hs-set', hasF);
    }
    setPanel.innerHTML = html + '</div>';
    setPanel.hidden = false;
    mountFilters();
  }

  function addMyWatch(row) {
    const key = row.dataset.brand + '|' + row.dataset.model;
    if (myWatches.some(wt => wt.key === key)) {
      myWatches = myWatches.filter(wt => wt.key !== key);   // togglen = verwijderen
    } else {
      if (myWatches.length >= MY_MAX) return;
      myWatches.push({ key: key, brand: row.dataset.brand, model: row.dataset.model,
        tpd: parseInt(row.dataset.tpd, 10), dir: window.HS_WINDER_MATCH.normDir(row.dataset.dir) });
    }
    renderMyBar();
  }

  function render() {
    const RAW = window.HS_TPD_DATA;
    if (!RAW) return;
    parkFilters();   // filters veilig in de holder vóór de tbody wordt herbouwd
    const raw = queryInp.value.trim();
    clearBtn.hidden = !queryInp.value;
    // op mobiel: pas de tabel tonen zodra er gezocht wordt (anders te onoverzichtelijk)
    if (isMobile() && !raw) {
      tbody.innerHTML = '<tr><td colspan="7" class="hs-tpd-empty">Zoek hierboven uw horloge om de instellingen en geschikte watch winders te zien.</td></tr>';
      countEl.textContent = '';
      pagWrap.hidden = true;
      mountFilters();
      return;
    }
    // getokeniseerd zoeken: elke term moet voorkomen in "merk + model" (samen), diakriet- en
    // interpunctie-ongevoelig. De hooiberg is samengevoegd zonder scheidingstekens, zodat
    // "tudor black bay", "daydate" (Day-Date) en "girardperregaux" (Girard-Perregaux) allemaal vinden.
    if (!searchIndex || searchIndex.length !== RAW.length) {
      searchIndex = RAW.map(r => normSearch(r[0] + ' ' + r[1] + ' ' + (r[4] || '')).replace(/[^a-z0-9]+/g, ''));
    }
    const terms = normSearch(raw).split(/\s+/).map(t => t.replace(/[^a-z0-9]+/g, '')).filter(Boolean);
    filtered = terms.length
      ? RAW.filter((r, i) => terms.every(t => searchIndex[i].indexOf(t) > -1))
      : RAW.slice();
    // Zonder zoekopdracht staat de hele database in de lijst. Sinds 10 okt 2026 (verzoek Guus) kan er op desktop
    // ook dan gebladerd worden met Vorige/Volgende onder de tabel. Bij een nieuwe of gewiste zoekopdracht zetten
    // de input- en wisknop-handlers de pagina terug op 1 (op mobiel verschijnt de tabel pas na zoeken).
    if (page * PER_PAGE >= filtered.length) page = 0;
    const slice = filtered.slice(page * PER_PAGE, (page + 1) * PER_PAGE);
    const total = Math.ceil(filtered.length / PER_PAGE);
    if (!filtered.length) {
      tbody.innerHTML = '<tr><td colspan="7" class="hs-tpd-empty">Geen resultaten gevonden.</td></tr>';
      countEl.textContent = '';
      pagWrap.hidden = true;
      mountFilters();
      return;
    }
    countEl.textContent = filtered.length === RAW.length
      ? RAW.length.toLocaleString('nl-NL') + ' modellen in de keuzehulp'
      : filtered.length.toLocaleString('nl-NL') + ' resultaten gevonden';
    tbody.innerHTML = slice.map((r, i) => {
      const dir = dirInfo(r[3]);
      const uid = 'hs-w-' + page + '-' + i;
      // v2-formaat: r[4] = modelnummer (leeg als onbekend); label = model + nummer
      const ref = r[4] || '';
      const label = ref ? (r[1] ? r[1] + ' ' + ref : ref) : r[1];
      const key = esc(r[0]) + '|' + esc(label);
      const added = myWatches.some(wt => wt.key === r[0] + '|' + label) ? ' is-added' : '';
      const windersBtn = '<button class="hs-tpd-winders-btn" type="button">Geschikte winders <span class="hs-tpd-caret">&#9660;</span></button>';
      const addBtn = '<button class="hs-tpd-add-btn' + added + '" data-add data-key="' + key + '" type="button" title="Voeg horloge toe aan mijn horloges">+</button>';
      const attrs = ' data-uid="' + uid + '" data-tpd="' + r[2] + '" data-dir="' + esc(r[3]) + '" data-brand="' + esc(r[0]) + '" data-model="' + esc(label) + '"';
      const desk = '<tr class="hs-tpd-desk-row"' + attrs + '>'
        + '<td class="hs-tpd-brand-cell" title="' + esc(r[0]) + '">' + r[0] + '</td>'
        + '<td title="' + esc(r[1]) + '">' + r[1] + '</td>'
        + '<td class="hs-tpd-ref-cell" title="' + esc(ref) + '">' + ref + '</td>'
        + '<td class="hs-tpd-tpd-val">' + r[2] + '</td>'
        + '<td><span class="hs-tpd-badge ' + dir.cls + '">' + dir.label + '</span></td>'
        + '<td>' + windersBtn + '</td>'
        + '<td>' + addBtn + '</td></tr>';
      const mob = '<tr class="hs-tpd-mob-row"' + attrs + '>'
        + '<td colspan="7"><div class="hs-tpd-mob-inner"><div class="hs-tpd-mob-text">'
        + '<span class="hs-tpd-mob-brand">' + r[0] + '</span><span class="hs-tpd-mob-model">' + r[1] + (ref ? ' <span class="hs-tpd-mob-ref">' + ref + '</span>' : '') + '</span>'
        + '<span class="hs-tpd-mob-specs">' + r[2] + ' TPD <span class="hs-tpd-badge ' + dir.cls + '">' + dir.label + '</span></span>'
        + '</div><span class="hs-tpd-mob-btn">' + windersBtn + addBtn + '</span></div></td></tr>';
      const panel = '<tr class="hs-winders-row" id="' + uid + '" hidden><td colspan="7"></td></tr>';
      return desk + mob + panel;
    }).join('');
    pagWrap.hidden = total <= 1;
    prevBtn.disabled = page === 0;
    nextBtn.disabled = page >= total - 1;
    pageInfo.textContent = 'Pagina ' + (page + 1) + ' van ' + total;
    mountFilters();   // filters terug naar het set-paneel (indien open), anders de holder
  }

  function toggleRow(row) {
    const uid = row.dataset.uid;
    const panelRow = document.getElementById(uid);
    if (!panelRow) return;
    parkFilters();
    const isOpen = !panelRow.hidden;
    tbody.querySelectorAll('.hs-winders-row:not([hidden])').forEach(p => { p.hidden = true; });
    tbody.querySelectorAll('.is-open').forEach(x => x.classList.remove('is-open'));
    if (isOpen) { mountFilters(); return; }
    // rij-paneel openen sluit het set-paneel (wederzijds uitsluitend); set-modus verlaten heft de aantal-standaard op
    if (!setPanel.hidden) { setPanel.hidden = true; aantalSel.value = ''; }
    const cell = panelRow.querySelector('td');
    if (!cell.dataset.rendered) {
      cell.innerHTML = windersPanel(row.dataset.tpd, row.dataset.dir, uid);
      cell.dataset.rendered = '1';
    }
    panelRow.hidden = false;
    tbody.querySelectorAll('[data-uid="' + uid + '"]').forEach(x => x.classList.add('is-open'));
    mountFilters();
  }

  function onFilterChange() {
    parkFilters();
    tbody.querySelectorAll('.hs-winders-row td').forEach(td => { td.dataset.rendered = ''; });
    tbody.querySelectorAll('.hs-winders-row:not([hidden])').forEach(p => {
      const row = tbody.querySelector('.hs-tpd-desk-row[data-uid="' + p.id + '"], .hs-tpd-mob-row[data-uid="' + p.id + '"]');
      if (!row) return;
      const cell = p.querySelector('td');
      cell.innerHTML = windersPanel(row.dataset.tpd, row.dataset.dir, p.id);
      cell.dataset.rendered = '1';
    });
    if (!setPanel.hidden) renderSetPanel();
    mountFilters();
  }

  filterEls.forEach(el => {
    el.addEventListener('change', onFilterChange);
  });
  // budget is een tekst-/nummerveld: ook live bijwerken tijdens typen (niet pas bij blur/'change')
  let budgetTimer;
  budgetInp.addEventListener('input', () => {
    clearTimeout(budgetTimer);
    budgetTimer = setTimeout(onFilterChange, 200);
  });

  function handleResultClicks(e, container) {
    const more = e.target.closest('[data-more]');
    if (more) {
      const uid = more.dataset.more;
      let res;
      if (uid === 'hs-set') {
        res = window.HS_WINDER_MATCH.matchesSet(myWatches.map(wt => ({ tpd: wt.tpd, dir: wt.dir })), readFilters(true));
      } else {
        const row = tbody.querySelector('.hs-tpd-desk-row[data-uid="' + uid + '"], .hs-tpd-mob-row[data-uid="' + uid + '"]');
        res = window.HS_WINDER_MATCH.matches(parseInt(row.dataset.tpd, 10),
          window.HS_WINDER_MATCH.normDir(row.dataset.dir), readFilters());
      }
      const altHidden = document.getElementById(uid + '-b');
      const altTile = (res.b.length && altHidden && altHidden.hidden)
        ? '<button class="hs-winder-tile hs-winder-tile--alt" data-alt="' + uid + '" type="button">Bekijk alternatieven (' + res.b.length + ')</button>'
        : '';
      document.getElementById(uid + '-a').innerHTML = res.a.map(m => card(m)).join('') + altTile;
      return true;
    }
    const alt = e.target.closest('[data-alt]');
    if (alt) {
      const el = document.getElementById(alt.dataset.alt + '-b');
      if (el) { el.hidden = false; el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      alt.remove();
      return true;
    }
    return false;
  }

  tbody.addEventListener('click', function (e) {
    const add = e.target.closest('[data-add]');
    if (add) {
      const row = add.closest('.hs-tpd-desk-row, .hs-tpd-mob-row');
      if (row) addMyWatch(row);
      return;
    }
    if (handleResultClicks(e, tbody)) return;
    if (e.target.closest('a')) return;
    const row = e.target.closest('.hs-tpd-desk-row, .hs-tpd-mob-row');
    if (row) toggleRow(row);
  });

  setPanel.addEventListener('click', function (e) {
    if (e.target.closest('[data-setclose]')) { parkFilters(); setPanel.hidden = true; aantalSel.value = ''; mountFilters(); return; }
    handleResultClicks(e, setPanel);
  });

  myChips.addEventListener('click', function (e) {
    const x = e.target.closest('[data-myx]');
    if (!x) return;
    myWatches.splice(parseInt(x.dataset.myx, 10), 1);
    renderMyBar();
  });
  myShow.addEventListener('click', function () { syncAantalToCount(); renderSetPanel(); setPanel.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  myClear.addEventListener('click', function () { myWatches = []; renderMyBar(); });

  function init() {
    const RAW = window.HS_TPD_DATA;
    if (!RAW) { setTimeout(init, 100); return; }
    // merk-watch-winder-filter vullen uit de winder-dataset
    const vendors = [...new Set((window.HS_WINDER_DATA || []).map(w => w.v))].sort();
    vendors.forEach(v => {
      const o = document.createElement('option');
      o.value = v;
      o.textContent = v;
      vendorSel.appendChild(o);
    });
    render();
  }

  queryInp.addEventListener('input',  () => { page = 0; render(); });
  // op mobiel: Enter sluit het toetsenbord zodat de resultaten zichtbaar worden
  queryInp.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); queryInp.blur(); } });
  // herteken bij het kruisen van de mobiel/desktop-grens (rotatie/resize)
  let lastMobile = isMobile();
  window.addEventListener('resize', () => {
    if (isMobile() !== lastMobile) { lastMobile = isMobile(); page = 0; render(); }
  });
  clearBtn.addEventListener('click',  () => { queryInp.value = ''; page = 0; render(); queryInp.focus(); });
  prevBtn.addEventListener('click',   () => { page--; render(); document.querySelector('.hs-tpd-section').scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  nextBtn.addEventListener('click',   () => { page++; render(); document.querySelector('.hs-tpd-section').scrollIntoView({ behavior: 'smooth', block: 'start' }); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
